// Twee talen. De taalkeuze in de lobby zet niet alleen de woordenlijst om
// maar ook de teksten, anders is de schakelaar half werk.

export type Lang = 'nl' | 'en'

type Dict = Record<string, string>

const nl: Dict = {
  brand: 'Treehouse Quiz',

  'phase.lobby': 'Maak je teams',
  'phase.describe': 'Jij omschrijft',
  'phase.guess': 'Raden maar',
  'phase.turn_over': 'Beurt voorbij',
  'phase.game_over': 'Afgelopen',

  'players.one': '1 speler',
  'players.many': '{count} spelers',

  'team.oranje': 'Team Oranje',
  'team.blauw': 'Team Blauw',
  'team.join': 'Kom erbij',
  'team.mine': 'Jouw team',

  'setting.language': 'Taal',
  'setting.scoring': 'Telling',
  'setting.listening': 'Meeluisteren',
  'listening.on': 'Aan',
  'listening.off': 'Uit',
  'listening.hint':
    'Het spel herkent tijdens een ronde welke woorden er geraden worden. De bot staat gedempt in het spraakkanaal en luistert alleen zolang de klok loopt. Er wordt niets opgenomen.',
  'listening.hint.off': 'De bot verlaat het spraakkanaal. Je vinkt de woorden zelf af.',
  'listening.wait': 'Weer aanzetten kan over {n}s.',
  'listening.offline': 'Geen bot beschikbaar, je vinkt de woorden zelf af.',
  'banner.live': 'Luistert mee',
  'banner.live.guess': 'Luistert mee. Roep het woord!',
  'banner.live.describe': 'Luistert mee naar je team.',
  'banner.idle': 'Microfoons dicht.',
  'setting.game': 'Spel',
  'game.reset': 'Alles resetten',
  'game.reset.confirm': 'Zeker weten?',
  'game.reset.hint': 'Zet alle standen op nul en stopt een lopende pot. Teams blijven staan.',
  'scoring.tug': 'Showdown',
  'scoring.points': 'Punten',
  'scoring.tug.hint':
    'De balk begint in het midden. Elk goed geraden woord trekt hem een vakje naar jouw kant, en wat de tegenpartij raadt trekt hem weer terug. Staat hij aan het eind van een ronde helemaal aan jouw kant, dan win je. Anders wint na {rounds} rondes wie er voorstaat.',
  'scoring.points.hint':
    'Elk goed geraden woord is een punt. Het eerste team op {target} punten wint.',
  'tug.turns': 'ronde {done} van {total}',
  'tug.centre': 'gelijk',

  'lobby.solo':
    'In je eentje oefenen. Je omschrijft en vinkt zelf af, zodat je de kaarten en de klok kunt uitproberen. Zodra er een tweede team is telt het als een echte pot.',
  'lobby.start': 'Start het spel',
  'lobby.pick': 'Kies eerst een team.',
  'privacy.open': 'Wat doet het spel met mijn gegevens?',
  'privacy.close': 'Terug',
  'privacy.discord': 'Privacyverklaring van Discord',
  'lobby.waiting': 'Wachten op de host',
  'lobby.waiting.hint': '{name} bepaalt de instellingen en start het spel.',
  'badge.host': 'host',

  'round.label': 'Ronde {n}',
  'round.describer': 'Omschrijver',
  'intro.you': 'Jij omschrijft',
  'intro.other': '{name} omschrijft',
  'intro.you.hint': 'Zo komen er vijf woorden. Omschrijf ze zonder het woord zelf te gebruiken.',
  'intro.other.hint': 'Straks roep je mee. Zeg gewoon wat je denkt dat het is.',
  'preview.read': 'Even doorlezen',
  'preview.ready': 'Start de klok',
  'preview.waiting': '{name} leest de kaart door',
  'play.guessed': '{done} van {total} geraden',
  'play.card': 'kaart {done} van {total}',
  'play.describes': '{name} omschrijft voor {team}',
  'play.shout': 'Roep het woord!',
  'play.watch': 'Je kijkt toe. Niet voorzeggen.',
  'play.good': 'Goed',
  'play.pass': 'Pas',

  'play.tally': 'goed, {done} van {total} gehad',

  'over.pulled': '{pulled} getrokken voor {team}',
  'over.draw': 'Gelijkspel',
  'over.points': 'voor {team}',
  'over.next': 'Volgende beurt',
  'over.winner': '{team} wint',
  'over.done': 'Klaar',
  'over.lobby': 'Terug naar de lobby',
  'over.waiting': 'Wachten op de host',

  'end.time_up': 'De tijd was om',
  'end.cards_done': 'Kaart uitgespeeld',
  'end.describer_left': 'De omschrijver ging weg',

  'loading.start': 'Opstarten',
  'loading.sdk': 'Verbinden met Discord',
  'loading.auth': 'Even inloggen',
  'loading.room': 'Room zoeken',

  'status.idle': 'niet verbonden',
  'status.connecting': 'verbinden',
  'status.open': 'verbonden',
  'status.reconnecting': 'opnieuw verbinden',
  'status.closed': 'verbinding gesloten',

  'bench.label': 'nog zonder team',
}

const en: Dict = {
  brand: 'Treehouse Quiz',

  'phase.lobby': 'Make your teams',
  'phase.describe': 'You describe',
  'phase.guess': 'Start guessing',
  'phase.turn_over': 'Turn over',
  'phase.game_over': 'Game over',

  'players.one': '1 player',
  'players.many': '{count} players',

  'team.oranje': 'Team Orange',
  'team.blauw': 'Team Blue',
  'team.join': 'Join',
  'team.mine': 'Your team',

  'setting.language': 'Language',
  'setting.scoring': 'Scoring',
  'setting.listening': 'Listening in',
  'listening.on': 'On',
  'listening.off': 'Off',
  'listening.hint':
    'The game recognises which words get guessed during a round. The bot sits muted in the voice channel and only listens while the clock is running. Nothing is recorded.',
  'listening.hint.off': 'The bot leaves the voice channel. You tick the words off yourself.',
  'listening.wait': 'You can switch it back on in {n}s.',
  'listening.offline': 'No bot available, you tick the words off yourself.',
  'banner.live': 'Listening',
  'banner.live.guess': 'Listening. Shout the word!',
  'banner.live.describe': 'Listening to your team.',
  'banner.idle': 'Microphones closed.',
  'setting.game': 'Game',
  'game.reset': 'Reset everything',
  'game.reset.confirm': 'Are you sure?',
  'game.reset.hint': 'Puts every score back to zero and stops a game in progress. Teams stay as they are.',
  'scoring.tug': 'Showdown',
  'scoring.points': 'Points',
  'scoring.tug.hint':
    'The bar starts in the middle. Every word you guess pulls it one square your way, and whatever the other team guesses pulls it back. If it is all the way over at the end of a round, you win. Otherwise, after {rounds} rounds whoever is ahead takes it.',
  'scoring.points.hint':
    'Every word guessed is one point. The first team to {target} points wins.',
  'tug.turns': 'round {done} of {total}',
  'tug.centre': 'even',

  'lobby.solo':
    'Practising on your own. You describe and tick off yourself, so you can try out the cards and the clock. As soon as a second team joins it counts as a real game.',
  'lobby.start': 'Start the game',
  'lobby.pick': 'Pick a team first.',
  'privacy.open': 'What does the game do with my data?',
  'privacy.close': 'Back',
  'privacy.discord': "Discord's privacy policy",
  'lobby.waiting': 'Waiting for the host',
  'lobby.waiting.hint': '{name} sets things up and starts the game.',
  'badge.host': 'host',

  'round.label': 'Round {n}',
  'round.describer': 'Describer',
  'intro.you': 'You describe',
  'intro.other': '{name} describes',
  'intro.you.hint': 'Five words coming up. Describe them without using the word itself.',
  'intro.other.hint': 'You will be shouting in a moment. Just say what you think it is.',
  'preview.read': 'Read them through',
  'preview.ready': 'Start the clock',
  'preview.waiting': '{name} is reading the card',
  'play.guessed': '{done} of {total} guessed',
  'play.card': 'card {done} of {total}',
  'play.describes': '{name} is describing for {team}',
  'play.shout': 'Shout the word!',
  'play.watch': 'You are just watching. No helping.',
  'play.good': 'Right',
  'play.pass': 'Pass',

  'play.tally': 'right, {done} of {total} done',

  'over.pulled': '{pulled} pulled for {team}',
  'over.draw': 'A draw',
  'over.points': 'for {team}',
  'over.next': 'Next turn',
  'over.winner': '{team} wins',
  'over.done': 'Done',
  'over.lobby': 'Back to the lobby',
  'over.waiting': 'Waiting for the host',

  'end.time_up': 'Time was up',
  'end.cards_done': 'Card finished',
  'end.describer_left': 'The describer left',

  'loading.start': 'Starting up',
  'loading.sdk': 'Connecting to Discord',
  'loading.auth': 'Signing you in',
  'loading.room': 'Finding the room',

  'status.idle': 'not connected',
  'status.connecting': 'connecting',
  'status.open': 'connected',
  'status.reconnecting': 'reconnecting',
  'status.closed': 'connection closed',

  'bench.label': 'no team yet',
}

const DICTS: Record<Lang, Dict> = { nl, en }

export function t(lang: Lang, key: string, vars: Record<string, string | number> = {}): string {
  const template = DICTS[lang][key] ?? DICTS.nl[key] ?? key
  return template.replace(/\{(\w+)\}/g, (_, name: string) => String(vars[name] ?? ''))
}

export function isLang(value: unknown): value is Lang {
  return value === 'nl' || value === 'en'
}
